import { useEffect } from 'react'
import { useTheme } from '@mui/material'
import { css } from '@emotion/css'

import { useWeb3Login } from 'src/hooks'
import { useAppKit } from '@reown/appkit/react'
import { useAccount, useDisconnect } from 'wagmi'
import { WalletConnectIcon } from 'src/assets/icons/v2/WalletConnectIcon'
import {
  SecondaryAuthContainer,
  IconWrapper,
} from 'src/components/sign-in/v2/SecondaryAuth/SecondaryAuth.styled'

export const Web3Provider = () => {
  // const { isDark } = useContext(ThemeSwitchContext)
  const theme = useTheme()

  const { open } = useAppKit()
  const { mutateAsync: login } = useWeb3Login()

  const { disconnect } = useDisconnect()
  const { address } = useAccount()

  useEffect(() => {
    handleLogin()

    async function handleLogin() {
      if (!address) return

      const resp = await login({ address })

      if (resp) return
      disconnect()
    }
  }, [address, login, disconnect])
  return (
    <>
      <div
        onClick={() => open()}
        className={css(
          SecondaryAuthContainer,
          `border: 0.5px solid ${theme.palette.custom.darkBlue2};`,
          `&&:hover {
          background-color: ${theme.palette.custom.grey};
        }`,
        )}
      >
        <div className={IconWrapper}>
          <WalletConnectIcon size={30} />
        </div>
      </div>
    </>
  )
}
